import { avatarAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys)

const avatarBaseStyle = definePartsStyle({
  container: {
    borderColor: 'presets.neutral.100',
    backgroundColor: 'presets.neutral.0',
    color: 'presets.turquoise.100',
    width: '29px',
    height: '29px',
    padding: '5px',
    _hover: {
      backgroundColor: 'presets.turquoise.100',
      borderColor: 'presets.turquoise.100',
      color: 'presets.neutral.0',
    },
    _active: {
      color: 'presets.neutral.0',
    },
  },
  label: {
    fontWeight: '600',
    fontSize: '11px',
    padding: '5px',
  },
})

export const avatarTheme = defineMultiStyleConfig({
  baseStyle: avatarBaseStyle,
})
